import React, {useState} from 'react';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import BulkLabelsActions from './components/bulk-labels-actions/index';
import {
	findLabels, findLabelsByType, getEnteredSearchValue,
	getFilteredStatus,
	getSelectedContactsGroup, labelsPageNumber,
	selectSeveralContactsGroups
} from '../../../../../../../../../actions/contactsGroupItemActions';
import Icon from '../../../../../../../../components/icon/index';
import Sprite from '../../../../../../../../components/sprite/components/status/index';
import SearchBar from '../../../../../../../../components/search-bar/index';
import T3 from './components/t3';
import {getSharingDetailsPopup} from '../../../../../../../../../actions/sharingDetailsActions';
import Button from '../../../../../../../../components/button';
import './index.css';

const ContactGroupHead = (props) => {

	const [displayFilter, setDisplayFilter] = useState(false);
	const {t} = useTranslation();

	const {
		findLabels,
		setFindLabels,
		filteredStatus,
		getFilteredStatus,
		enteredSearchValue,
		getEnteredSearchValue,
		getSharingDetailsPopup,
		guidedTours,
		labelsPageSize,
		profile,
		setFindLabelsByType,
		setLabelsPageNumber,
		selectSeveralContactsGroups,
		setSelectSeveralContactsGroups,
		displayLabelSearch
	} = props;

	const changeHandler = (e) => {

		if (e.currentTarget.checked) {
			let labels = [];

			/*document.querySelectorAll('.list-of-group-body .label').forEach( item => {
				if( item.dataset.permission ==='OWNER' || item.dataset.permission === 'CAN_SHARE' ){

				if(!item.children[0].children[0].checked){
					item.children[0].children[0].checked = true;
					if(!item.classList.contains('selected')){
						item.classList.add('selected');
					}
				}

				labels = labels.concat({
					'id' : item.dataset.id,
					'name' : item.dataset.name,
					'status' : item.dataset.status,
					'permission' : item.dataset.permission,
					'ownerId' : item.dataset.ownerId,
				})
			}});*/

			findLabels.contactsGroups.forEach(label => {
				if (label.permission === "OWNER" || label.permission === "CAN_SHARE") {
					labels = labels.concat({
						'id': label.id,
						'name': label.name,
						'status': label.status,
						'permission': label.permission,
						'ownerId': label.ownerId,
					})
				}
			});

			setSelectSeveralContactsGroups(labels);

			document.querySelectorAll(".label .custom-control-input").forEach(item => {
				item.checked = item.dataset.permission === 'OWNER' || item.dataset.permission === 'CAN_SHARE';
			});

		} else {

			document.querySelectorAll(".label .custom-control-input").forEach(item => {
				item.checked = false
			});

			setSelectSeveralContactsGroups([]);
		}

	};

	const searchLabelHandler = (e) => {
		setLabelsPageNumber(1);
		getEnteredSearchValue(e.target.value);

		if (document.querySelector('.list-of-group-body')) {
			document.querySelector('.list-of-group-body').scrollTop = 0;
		}
	};

	const handler = (e) => {
		e.preventDefault();
		setDisplayFilter(!displayFilter)
	};

	const mouseLeave = () => {
		setDisplayFilter(false)
	};

	const removeStatusFilter = (e) => {
		e.preventDefault();
		getFilteredStatus(null);
		displayFilteredContactsGroup();
	};

	const newLabelHandler = () => {
		getSharingDetailsPopup([true, 'new_label']);
	};

	const displayFilteredContactsGroup = (e) => {

		setDisplayFilter(false);

		setLabelsPageNumber(1);


		if (e) {

			/*
			* If a type has been chosen
			* */

			getFilteredStatus(e.currentTarget.dataset.value);
			setFindLabelsByType(e.currentTarget.dataset.value);

		} else {
			if (enteredSearchValue !== "") {
				setFindLabels(false, true);
			} else {
				setFindLabels(labelsPageSize, true);
			}
		}

	};

	const showT3 = () => {

		let hasSharedLabels = false;

		if (findLabels && findLabels.contactsGroups.length > 0) {
			findLabels.contactsGroups.find(label => {
				if (label.status === 'SHARED') {
					return hasSharedLabels = true;
				}
				return false;
			});
		}

		if (!hasSharedLabels
			&& guidedTours.t3 === false
			&& (findLabels && findLabels.contactsGroups.length > 0)
			&& (filteredStatus === null || filteredStatus === "NOT_SHARED")) {

			if (profile && profile.domain && profile.domain.plan !== "INVITED") {
				return <T3/>
			} else {
				return null;
			}

		} else {
			return null;
		}

	};

	const filterDropDown = () => {
		if (displayFilter) {
			return (
				<ul onMouseLeave={mouseLeave}>
					<li>
						<button className="btn btn-link" data-value="SHARED" onClick={displayFilteredContactsGroup}>
							{t('textShared')}
						</button>
					</li>
					<li>
						<button className="btn btn-link" data-value="NOT_SHARED" onClick={displayFilteredContactsGroup}>
							{t('textNotShared')}
						</button>
					</li>
					<li>
						<button className="btn btn-link" data-value="SHARED_WITH_ME"
								onClick={displayFilteredContactsGroup}>
							{t('textSharedWithMe')}
						</button>
					</li>
				</ul>
			)
		} else {
			return "";
		}
	};

	return (
		<div className="list-of-group-head">
			<div className="d-flex align-items-center pt-2">
				<span className="text-nowrap font-weight-bold">
					{t("textContactList")}
				</span>
				<div className="d-flex p-2">
					<div className="status-title text-capitalize" onClick={handler}>
						<Icon className="mx-1" name="filter"/>
					</div>
					{
						(filteredStatus)
							?
							<div className="d-flex align-items-center status">
								<Sprite width={12} height={12} status={filteredStatus}/>
								<Button onClick={removeStatusFilter} className="delete p-0 btn-link">×</Button>
							</div>
							:
							""
					}
					{filterDropDown()}
				</div>
				{
					showT3()
				}
				<Button className="btn-primary ml-auto" title={t("textSharedWithMeLabelCreate")} onClick={newLabelHandler}>
					<svg
						fill="none"
						viewBox="0 0 16 16"
						role="presentation"
						className="mr-2"
						width={16}
					>
						<path
							fill="currentcolor"
							fillRule="evenodd"
							d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z"
							clipRule="evenodd"
						/>
					</svg>
					Add label
				</Button>
			</div>
			<div className="list-of-group-head__options d-flex align-items-center justify-content-between py-2">
				<div className="custom-control custom-checkbox my-1 mr-sm-2">
					<input onChange={changeHandler} type="checkbox" className="custom-control-input"
						   id="massLabelsSelection"/>
					<label className="custom-control-label" htmlFor="massLabelsSelection"/>
				</div>
				{
					selectSeveralContactsGroups.length > 0
						?
						<div className="px-2 overflow-hidden">
							<BulkLabelsActions/>
						</div>
						:
						displayLabelSearch && <div className="px-2 overflow-hidden">
							<SearchBar
								id="searchLabel"
								label="Search a label"
								title={t("textSearchLabel")}
								srOnly={true}
								className="search-label mr-2"
								onChange={searchLabelHandler}
								placeholder={t("textSearchLabel")}
								value={enteredSearchValue}
							/>
						</div>
				}
			</div>
		</div>
	)
};

const mapStateToProps = (state) => {
	return {
		findLabels: state.contactsGroupItemReducer.findLabels,
		filteredStatus: state.contactsGroupItemReducer.getFilteredStatus,
		enteredSearchValue: state.contactsGroupItemReducer.getEnteredSearchValue,
		labelsPageSize: state.contactsGroupItemReducer.labelsPageSize,
		guidedTours: state.guidedToursReducer.guidedTours,
		profile: state.profileReducer.getProfile,
		selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
		displayLabelSearch: state.contactsGroupItemReducer.displayLabelSearch
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getEnteredSearchValue: (string) => {
			dispatch(getEnteredSearchValue(string))
		},
		getFilteredStatus: (object) => {
			dispatch(getFilteredStatus(object))
		},
		getSelectedContactsGroup: (object) => {
			dispatch(getSelectedContactsGroup(object))
		},
		getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
		setSelectSeveralContactsGroups : (array) => {
			dispatch(selectSeveralContactsGroups(array))
		},
		setFindLabels : (pageSize, directLaunch) => {
			dispatch(findLabels(pageSize, directLaunch))
		},
		setFindLabelsByType : (type, pageSize) => {
			dispatch(findLabelsByType(type, pageSize))
		},
		setLabelsPageNumber: (int) => {
			dispatch(labelsPageNumber(int))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactGroupHead);
